/**
 * Shopify Ajaxify Shop. 
 * 
 * @uses Modified Shopify jQuery API (link to it)
 *
 */

// Binding events every time when open modal window with cart
var  bindEventsInCart = function(){
  
  var modalForm = $(".modal-popup form");
    $additionCheckoutBlock = modalForm.find("#additional-checkout-block");
    $additionCheckoutBlock.load('/cart #addCheckoutBtn', function() {
      if (window.Shopify && Shopify.StorefrontExpressButtons) {
        Shopify.StorefrontExpressButtons.initialize();
      }
    });

  $(".cart_menu").on("click",".remove_item_button", function(e){
    e.preventDefault();

    var el = $(this),
        id = el.data('id') || null;

    Shopify.removeItem(id, function(cart){
      Shopify.updateQuickCart(cart);
    });
  });

  /////////////////////////////////////
  // Qty for cart modal
  /////////////////////////////////////
  jQuery(".cart_menu").on("click", ".minus_btn", function () {
    var inputEl = jQuery(this).parent().find("input");
    var qty = inputEl.val();
    if (jQuery(this).parent().hasClass("minus_btn"))
      qty++;
    else
      qty--;
    if (qty < 0)
      qty = 0;
    inputEl.val(qty);

    var quantity = qty,
        id = inputEl.data("id");
    if(quantity != 0){
      Shopify.changeItem(id, quantity, function(cart){
        Shopify.updateQuickCart(cart);
      });
    }
    else{
      Shopify.removeItem(id, function(cart){
        Shopify.updateQuickCart(cart);
      });
    }
  })


  jQuery(".cart_menu").on("click",".plus_btn", function () {
    var inputEl = jQuery(this).parent().find("input");
    var qty = inputEl.val();

    if (jQuery(this).hasClass("plus_btn"))
      qty++;
    else
      qty--;
    if (qty < 0)
      qty = 0;
   
    var quantity = qty,
        id = inputEl.data("id"),
        maxqtyval = inputEl.data("maxqtyval"); 
    //var maxqtyval = $("#"+id+"_maxQty").val();
    
    console.log(quantity + " <==> " +id + " <==> " +maxqtyval);

    if( (maxqtyval != 0) && (quantity > maxqtyval)){
      jQuery('.ajaxcart__item__' + id + '__errors').show().delay(3000).fadeOut();
    }
    else{
    
    Shopify.changeItem(id, quantity, function(cart){
      var updatedItem = cart.items.filter(function(item){ return item.variant_id == id });
      if(updatedItem.length && updatedItem[0].quantity == quantity){
        Shopify.updateQuickCart(cart);
        inputEl.val(quantity);
      }
      else{
        jQuery('.ajaxcart__item__' + id + '__errors').show().delay(2000).fadeOut();
      }
    });

    }

  })

  /// Save cart note///
  $(".cart_menu").on("focusout","textarea", function(){
    var note = $(this).val(),
        textareas = $(".div.cart_menu").find("textarea").add($(".cart_tbl textarea"));

    Shopify.updateCartNote(note, function(){
      $(textareas).each(function () {
        $(this).val(note);
        $(this).text(note);
      });
    });
  });

  /// Closing modal///
  $(".cart_menu").on("click",".info_btn", function(){
    var magnificPopup = $.magnificPopup.instance;
    if(typeof magnificPopup !== 'undefined'){
      magnificPopup.close();
    }
  });
  $(".cart_menu").on("click",".btn_close", function(){
    var magnificPopup = $.magnificPopup.instance;
    if(typeof magnificPopup !== 'undefined'){
      magnificPopup.close();
    }
  });
  
}

jQuery(document).ready(function() { 
  //Begin Wrapper

  var jQ = jQuery;

  /**
 * Collection of Selectors for various pieces on the page we need to update 
 *
 * I've tried to keep these as general and flexible as possible, but 
 * if you are doing your own markup, you may find you need to change some of these.
 *
 */
  var selectors = {
    // Any elements(s) with this selector will have the total item count put there on add to cart.
    TOTAL_ITEMS: '.count', 
    TOTAL_PRICE: '.cart-total-price',
    SUBMIT_ADD_TO_CART: 'input[type=image], input.submit-add-to-cart',
    FORM_ADD_TO_CART: 'form[action*="/cart/add"]',
    FORM_UPDATE_CART: 'form[name=cartform]',
    //The actual Update Button
    FORM_UPDATE_CART_BUTTON: 'form[name=cartform] input[name=update]',
    //All the buttons on the form
    FORM_UPDATE_CART_BUTTONS: 'input[type=image], input.button-update-cart',
    LINE_ITEM_ROW: '.cart-line-item',
    LINE_ITEM_QUANTITY_PREFIX: 'input#updates_',
    LINE_ITEM_PRICE_PREFIX: '.cart-line-item-price-',
    LINE_ITEM_REMOVE: '.remove a',
    EMPTY_CART_MESSAGE: '#empty',
    QUICK_CART_MENU: 'div.cart_menu',
    CART_PAGE_MENU: '.cart_tbl'
  };

  /**
 * Collection of text strings. This is where you would change for a diff language, for example. 
 *
 */
  var text = {
    ITEM: 'Item', 
    ITEMS: 'Items'
  };

  //Convenience method to format money. 
  //Can just transform the amount here if needed
  window.formatMoney = function(price) {
    return Shopify.formatMoney(price, app.data.money_format);
  };

  //We only want to interrupt the UPDATE, not the CHECKOUT process
  jQ(selectors.FORM_UPDATE_CART_BUTTON).click(function(e) {
    e.preventDefault();
    jQ(e.target.form).find(selectors.FORM_UPDATE_CART_BUTTONS).attr('disabled', true).addClass('disabled');
    Shopify.updateCartFromForm(e.target.form);
  });

  //Delegate the Remove Link functionality on the cart page.
  jQ(selectors.FORM_UPDATE_CART).delegate(selectors.LINE_ITEM_REMOVE, 'click', function(e) {
    e.preventDefault();
    //Get the variant ID from the URL
    var vid = this.href.split('/').pop().split('?').shift();
    Shopify.removeItem(vid);
    jQ(this).parents(selectors.LINE_ITEM_ROW).remove();
  });

  /**
 * Shopify.showModal
 * 
 * @param string contents
 * @param integer hideDelay
 */
  Shopify.modalTimer = false;
  Shopify.showModal = function(contents,hideDelay) { 
     if($(".variations .swatch.clearfix").length){
        var variant_selected = true;
        $( ".variations  .swatch  .swatch-element input" ).each(function( index ) {
          var inp_name = $( this ).attr("name");
          if(document.querySelector(".variations  .swatch  .swatch-element input[name='"+inp_name+"']:checked")){
          }else{
            variant_selected = false;
          }
        });
        if(variant_selected){
        }else{
            return;
        }
      }
    $("html").css("overflow-y","hidden");

    //Ensure the plugin is loaded
    if(typeof $().magnificPopup !== 'function'){ return }

    //Check the function vars have been sent
    if(typeof contents === 'undefined'){ return }
    //if(typeof hideDelay === 'undefined'){ var hideDelay = 7000 /* default */ }

    //Open the modal
    $.magnificPopup.open({
      items: {
        src: '<div class="mfp-with-anim modal-popup">'+contents+'</div>',
        type: 'inline'
      },
      mainClass: 'mfp-move-from-top',
      removalDelay: 1000,
      callbacks: {
        close: function() {
          $("html").css("overflow-y","auto");
        }
      }
    });

    bindEventsInCart();
  };

  
  Shopify.addImageSize = function(src,size){
    if(typeof size === 'undefined'){ return src; }
    if(src === null){ return "\/\/irtististore.com\/cdn\/shop\/t\/63\/assets\/no-image.gif?v=70791486150938284421690218556" }
    size = '_' + size + '.';
    return src.replace(/.([^.]*)$/,size+'$1');
  };

  
  Shopify.updateQuickCart = function(cart){
    
    var t = jQ(selectors.QUICK_CART_MENU),
        c = jQ(selectors.CART_PAGE_MENU);
 
    if(t.length){

      if(cart.items.length){

        var toAppend = [],
            tableHeader = '<ul><li>Photo</li>'+
        '<li>Name</li>'+
        '<li>Price</li>'+
        '<li>Quantity</li>'+
        '<li>Total</li></ul>';

        for (var i = 0; i < cart.items.length; i++) {
                if(cart.items[i].handle == 'qurbani-udhiyah-animal' || cart.items[i].handle == 'qurbani-udhiyah-cow-share'){
        console.log(cart.items[i]);
                if(cart.items[i].properties == null){
                 var itemPrice = cart.items[i].price,
              totalPrice = cart.total_price,
              linePrice = cart.items[i].line_price,
              title = cart.items[i].variant_title,
              cartNote = cart.note,
			  productHandle = cart.items[i].handle,
              maxQtyVal = $("#"+cart.items[i].product_id+"_maxQty").val();

		  
//           jQuery.getJSON('/products/'+productHandle+'.js', function(product) {
//           }).done(function(product) {

//             for(var t=0; t < product.tags.length; t++){
//               var ta = product.tags[t];
               
//               if( ta.indexOf('maxQty_') !== -1 ){
// 				 var res = ta.split("_"); 
//                  maxQtyVal = parseInt(res[1]);
//               }
 
//             }

//           });
		 

          if(title == null){
            title = "";
          }
          if(cartNote == null){
            cartNote = "";
          }

          //convert prices
          var itemPriceConverted = Shopify.formatMoney(itemPrice,app.data.money_format),
              totalPriceConverted = Shopify.formatMoney(totalPrice,app.data.money_format),
              linePriceConverted = Shopify.formatMoney(linePrice,app.data.money_format);                  
          
          

          var row = '<ul><li><div class="thumb"><a href="' + cart.items[i].url + 
              '"><img src="' + Shopify.addImageSize(cart.items[i].image,'small') + '" alt="' + cart.items[i].title + 
              '"></a></div></li><li><h5><a href="' + cart.items[i].url + 
              '" class="item-name">' + cart.items[i].product_title + 
              '</a></h5><p class="product-type">'+title+'</p><a href="#" data-id="'+cart.items[i].id+'" class="remove_item_button">REMOVE</a></li>'+
              '<li><p class="mobile-label-price">Price</p><span class="money price">'+itemPriceConverted+'</span></li>'+
              '<li><p class="mobile-label-quantity">Quantity</p><a class="minus_btn"></a><input type="text" name="updates[]" class="txtbox" min="0" id="updates_'+cart.items[i].id+'" data-id="'+cart.items[i].id+'" value="'+cart.items[i].quantity+'" data-maxQtyVal="'+maxQtyVal+'" /><a class="plus_btn"></a>'+
              '<div class="ajaxcart__errors text-center ajaxcart__item__'+cart.items[i].id+'__errors">All available stock is in cart</div></li>'+    
              '<li><p class="mobile-label-total">Total</p><span class="money price">'+ linePriceConverted +'</span>'+
              '</li></ul>';
          toAppend.push(row);                       
           console.log(row); 
                }
                else{
          var ip1 = "";        
          if(cart.items[i].properties['person_name1']){
           ip1 = cart.items[i].properties['person_name1'];
          }
          var ip2 = "";        
          if(cart.items[i].properties['person_name2']){
           ip2 = cart.items[i].properties['person_name2'];
          }
          var ip3 = "";        
          if(cart.items[i].properties['person_name3']){
           ip3 = cart.items[i].properties['person_name3'];
          }
          var ip4 = "";        
          if(cart.items[i].properties['person_name4']){
           ip4 = cart.items[i].properties['person_name4'];
          }
          var ip5 = "";        
          if(!cart.items[i].properties['person_name5']){
           ip5 = cart.items[i].properties['person_name5'];
          }
          var ip6 = "";        
          if(cart.items[i].properties['person_name6']){
           ip6 = cart.items[i].properties['person_name6'];
          }
          var ip7 = "";        
          if(cart.items[i].properties['person_name7']){
           ip7 = cart.items[i].properties['person_name7'];
          }
          var ip8 = "";        
          if(cart.items[i].properties['person_name8']){
           ip8 = cart.items[i].properties['person_name8'];
          }
          var ip9 = "";        
          if(cart.items[i].properties['person_name9']){
           ip9 = cart.items[i].properties['person_name9'];
          }
          var ip10 = "";        
          if(cart.items[i].properties['person_name10']){
           ip10 = cart.items[i].properties['person_name10'];
          }
          var ipr = "";
          if(cart.items[i].properties['for_poor_and_needy_families']){
           ipr = cart.items[i].properties['for_poor_and_needy_families'];
          }  
           var ipr_1 = "";
          if(cart.items[i].properties['qurbani_meat_to_be_cut']){
           ipr_1 = cart.items[i].properties['qurbani_meat_to_be_cut'];
          }  
                
          var itemPrice = cart.items[i].price,
              itemProp1 = ip1,
              itemProp2 = ip2,
              itemProp3 = ip3,
              itemProp4 = ip4,
              itemProp5 = ip5,
              itemProp6 = ip6,
              itemProp7 = ip7,
              itemProp8 = ip8,
              itemProp9 = ip9,
              itemProp10 = ip10,
              itemPropRadio = ipr,
              itemPropRadio_1 = ipr_1,
              totalPrice = cart.total_price,
              linePrice = cart.items[i].line_price,
              title = cart.items[i].variant_title,
              cartNote = cart.note,
			  productHandle = cart.items[i].handle,
              maxQtyVal = $("#"+cart.items[i].product_id+"_maxQty").val();

		  
//           jQuery.getJSON('/products/'+productHandle+'.js', function(product) {
//           }).done(function(product) {

//             for(var t=0; t < product.tags.length; t++){
//               var ta = product.tags[t];
               
//               if( ta.indexOf('maxQty_') !== -1 ){
// 				 var res = ta.split("_"); 
//                  maxQtyVal = parseInt(res[1]);
//               }
 
//             }

//           });
                
                
		 
                if(itemProp1 !=""){
                var itemProp1_nw = "person_name1 : "+ itemProp1;
                var itemradio_nw = "for_poor_and_needy_families : "+ itemPropRadio;
                var itemradio_nw_1 = "qurbani_meat_to_be_cut : "+ itemPropRadio_1;

                }
                if(itemProp2 !=""){
                var itemProp1_nw = "person_name1 : "+ itemProp1;
                var itemProp2_nw = "person_name2 : "+ itemProp2;
                var itemradio_nw = "for_poor_and_needy_families : "+ itemPropRadio;
                var itemradio_nw_1 = "qurbani_meat_to_be_cut : "+ itemPropRadio_1;


                }
                                

                if(itemProp3 !=""){
                var itemProp1_nw = "person_name1 : "+ itemProp1;
                var itemProp2_nw = "person_name2 : "+ itemProp2;
                var itemProp3_nw = "person_name3 : "+ itemProp3;
                var itemradio_nw = "for_poor_and_needy_families : "+ itemPropRadio;
                
                var itemradio_nw_1 = "qurbani_meat_to_be_cut : "+ itemPropRadio_1;

                }
                if(itemProp4 !=""){
                var itemProp1_nw = "person_name1 : "+ itemProp1;
                var itemProp2_nw = "person_name2 : "+ itemProp2;
                var itemProp3_nw = "person_name3 : "+ itemProp3;
                var itemProp4_nw = "person_name4 : "+ itemProp4;
                var itemradio_nw = "for_poor_and_needy_families : "+ itemPropRadio;
                var itemradio_nw_1 = "qurbani_meat_to_be_cut : "+ itemPropRadio_1;

                }
                if(itemProp5 !=""){
                var itemProp1_nw = "person_name1 : "+ itemProp1;
                var itemProp2_nw = "person_name2 : "+ itemProp2;
                var itemProp3_nw = "person_name3 : "+ itemProp3;
                var itemProp4_nw = "person_name4 : "+ itemProp4;
                var itemProp5_nw = "person_name5 : "+ itemProp5;
                var itemradio_nw = "for_poor_and_needy_families : "+ itemPropRadio;
                var itemradio_nw_1 = "qurbani_meat_to_be_cut : "+ itemPropRadio_1;

                }
                if(itemProp6 !=""){
                var itemProp1_nw = "person_name1 : "+ itemProp1;
                var itemProp2_nw = "person_name2 : "+ itemProp2;
                var itemProp3_nw = "person_name3 : "+ itemProp3;
                var itemProp4_nw = "person_name4 : "+ itemProp4;
                var itemProp5_nw = "person_name5 : "+ itemProp5;
                var itemProp6_nw = "person_name6 : "+ itemProp6;
                var itemradio_nw = "for_poor_and_needy_families : "+ itemPropRadio;
                var itemradio_nw_1 = "qurbani_meat_to_be_cut : "+ itemPropRadio_1;

                }
                if(itemProp7 !=""){
                var itemProp1_nw = "person_name1 : "+ itemProp1;
                var itemProp2_nw = "person_name2 : "+ itemProp2;
                var itemProp3_nw = "person_name3 : "+ itemProp3;
                var itemProp4_nw = "person_name4 : "+ itemProp4;
                var itemProp5_nw = "person_name5 : "+ itemProp5;
                var itemProp6_nw = "person_name6 : "+ itemProp6;
                var itemProp7_nw = "person_name7 : "+ itemProp7;
                var itemradio_nw = "for_poor_and_needy_families : "+ itemPropRadio;
                var itemradio_nw_1 = "qurbani_meat_to_be_cut : "+ itemPropRadio_1;


                }
                if(itemProp8 !=""){
                var itemProp1_nw = "person_name1 : "+ itemProp1;
                var itemProp2_nw = "person_name2 : "+ itemProp2;
                var itemProp3_nw = "person_name3 : "+ itemProp3;
                var itemProp4_nw = "person_name4 : "+ itemProp4;
                var itemProp5_nw = "person_name5 : "+ itemProp5;
                var itemProp6_nw = "person_name6 : "+ itemProp6;
                var itemProp7_nw = "person_name7 : "+ itemProp7;
                var itemProp8_nw = "person_name8 : "+ itemProp8;
                var itemradio_nw = "for_poor_and_needy_families : "+ itemPropRadio;
                var itemradio_nw_1 = "qurbani_meat_to_be_cut : "+ itemPropRadio_1;


                }
                if(itemProp9 !=""){
                var itemProp1_nw = "person_name1 : "+ itemProp1;
                var itemProp2_nw = "person_name2 : "+ itemProp2;
                var itemProp3_nw = "person_name3 : "+ itemProp3;
                var itemProp4_nw = "person_name4 : "+ itemProp4;
                var itemProp5_nw = "person_name5 : "+ itemProp5;
                var itemProp6_nw = "person_name6 : "+ itemProp6;
                var itemProp7_nw = "person_name7: "+ itemProp7;
                var itemProp8_nw = "person_name8 : "+ itemProp8;
                var itemProp9_nw = "person_name9 : "+ itemProp9;
                var itemradio_nw = "for_poor_and_needy_families : "+ itemPropRadio;
                var itemradio_nw_1 = "qurbani_meat_to_be_cut : "+ itemPropRadio_1;


                }
                if(itemProp10 !=""){
                var itemProp1_nw = "person_name1 : "+ itemProp1;
                var itemProp2_nw = "person_name2 : "+ itemProp2;
                var itemProp3_nw = "person_name3 : "+ itemProp3;
                var itemProp4_nw = "person_name4 : "+ itemProp4;
                var itemProp5_nw = "person_name5 : "+ itemProp5;
                var itemProp6_nw = "person_name6 : "+ itemProp6;
                var itemProp7_nw = "person_name7: "+ itemProp7;
                var itemProp8_nw = "person_name8 : "+ itemProp8;
                var itemProp9_nw = "person_name9 : "+ itemProp9;
                var itemProp10_nw = "person_name10 : "+ itemProp10;
                var itemradio_nw = "for_poor_and_needy_families : "+ itemPropRadio;
                var itemradio_nw_1 = "qurbani_meat_to_be_cut : "+ itemPropRadio_1;

              }
                
          if(title == null){
            title = "";
          }
          if(cartNote == null){
            cartNote = "";
          }

          //convert prices
          var itemPriceConverted = Shopify.formatMoney(itemPrice,app.data.money_format),
              totalPriceConverted = Shopify.formatMoney(totalPrice,app.data.money_format),
              linePriceConverted = Shopify.formatMoney(linePrice,app.data.money_format);                  
          
          

                if(cart.items[i].handle == 'qurbani-udhiyah-cow-share'){
          var row = '<ul><li><div class="thumb"><a href="' + cart.items[i].url + 
              '"><img src="' + Shopify.addImageSize(cart.items[i].image,'small') + '" alt="' + cart.items[i].title + 
              '"></a></div></li><li><h5><a href="' + cart.items[i].url + 
              '" class="item-name">' + cart.items[i].product_title + 
              '</a></h5><p class="product-prop '+itemProp1_nw +'">'+itemProp1_nw+'</p><p class="product-prop '+itemProp2_nw+'">'+itemProp2_nw+'</p><p class="product-prop '+itemProp3_nw +'">'+itemProp3_nw+'</p><p class="product-prop '+itemProp4_nw +'">'+itemProp4_nw+'</p><p class="product-prop '+itemProp5_nw +'">'+itemProp5_nw+'</p><p class="product-prop '+itemProp6_nw +'">'+itemProp6_nw+'</p><p class="product-prop '+itemProp7_nw +'">'+itemProp7_nw+'</p><p class="product-prop '+itemProp8_nw +'">'+itemProp8_nw+'</p><p class="product-prop '+itemProp9_nw +'">'+itemProp9_nw+'</p><p class="product-prop '+itemProp10_nw +'">'+itemProp10_nw+'</p><p class="product-type">'+title+'</p><a href="#" data-id="'+cart.items[i].id+'" class="remove_item_button">REMOVE</a></li>'+
              '<li><p class="mobile-label-price">Price</p><span class="money price">'+itemPriceConverted+'</span></li>'+
              '<li><p class="mobile-label-quantity">Quantity</p><a class="minus_btn"></a><input type="text" name="updates[]" class="txtbox" min="0" id="updates_'+cart.items[i].id+'" data-id="'+cart.items[i].id+'" value="'+cart.items[i].quantity+'" data-maxQtyVal="'+maxQtyVal+'" /><a class="plus_btn"></a>'+
              '<div class="ajaxcart__errors text-center ajaxcart__item__'+cart.items[i].id+'__errors">All available stock is in cart</div></li>'+    
              '<li><p class="mobile-label-total">Total</p><span class="money price">'+ linePriceConverted +'</span>'+
              '</li></ul>';
                }
                else{
                 var row = '<ul><li><div class="thumb"><a href="' + cart.items[i].url + 
              '"><img src="' + Shopify.addImageSize(cart.items[i].image,'small') + '" alt="' + cart.items[i].title + 
              '"></a></div></li><li><h5><a href="' + cart.items[i].url + 
              '" class="item-name">' + cart.items[i].product_title + 
              '</a></h5><p class="product-prop '+itemProp1_nw +'">'+itemProp1_nw+'</p><p class="product-prop '+itemProp2_nw+'">'+itemProp2_nw+'</p><p class="product-prop '+itemProp3_nw +'">'+itemProp3_nw+'</p><p class="product-prop '+itemProp4_nw +'">'+itemProp4_nw+'</p><p class="product-prop '+itemProp5_nw +'">'+itemProp5_nw+'</p><p class="product-prop '+itemProp6_nw +'">'+itemProp6_nw+'</p><p class="product-prop '+itemProp7_nw +'">'+itemProp7_nw+'</p><p class="product-prop '+itemProp8_nw +'">'+itemProp8_nw+'</p><p class="product-prop '+itemProp9_nw +'">'+itemProp9_nw+'</p><p class="product-prop '+itemProp10_nw +'">'+itemProp10_nw+'</p><p class="product-prop '+itemradio_nw+'">'+itemradio_nw+'</p><p class="product-prop '+itemradio_nw_1+'">'+itemradio_nw_1+'</p><p class="product-type">'+title+'</p><a href="#" data-id="'+cart.items[i].id+'" class="remove_item_button">REMOVE</a></li>'+
              '<li><p class="mobile-label-price">Price</p><span class="money price">'+itemPriceConverted+'</span></li>'+
              '<li><p class="mobile-label-quantity">Quantity</p><a class="minus_btn"></a><input type="text" name="updates[]" class="txtbox" min="0" id="updates_'+cart.items[i].id+'" data-id="'+cart.items[i].id+'" value="'+cart.items[i].quantity+'" data-maxQtyVal="'+maxQtyVal+'" /><a class="plus_btn"></a>'+
              '<div class="ajaxcart__errors text-center ajaxcart__item__'+cart.items[i].id+'__errors">All available stock is in cart</div></li>'+    
              '<li><p class="mobile-label-total">Total</p><span class="money price">'+ linePriceConverted +'</span>'+
              '</li></ul>';
                }
                
          toAppend.push(row);                       
           console.log(row);
                }
                }
                else{
                 var itemPrice = cart.items[i].price,
              totalPrice = cart.total_price,
              linePrice = cart.items[i].line_price,
              title = cart.items[i].variant_title,
              cartNote = cart.note,
			  productHandle = cart.items[i].handle,
              maxQtyVal = $("#"+cart.items[i].product_id+"_maxQty").val();
              car_properties = cart.items[i].properties;
              combined_value = "";
                if(car_properties){
              properties_key = Object.getOwnPropertyNames(car_properties)[0];
              properties_value = car_properties[properties_key];
                if(properties_key && properties_value != 'undefined'){
                combined_value = properties_key +":"+properties_value;
                }
                }
//           jQuery.getJSON('/products/'+productHandle+'.js', function(product) {
//           }).done(function(product) {

//             for(var t=0; t < product.tags.length; t++){
//               var ta = product.tags[t];
               
//               if( ta.indexOf('maxQty_') !== -1 ){
// 				 var res = ta.split("_"); 
//                  maxQtyVal = parseInt(res[1]);
//               }
 
//             }

//           });
		 

          if(title == null){
            title = "";
          }
          if(cartNote == null){
            cartNote = "";
          }

          //convert prices
          var itemPriceConverted = Shopify.formatMoney(itemPrice,app.data.money_format),
              totalPriceConverted = Shopify.formatMoney(totalPrice,app.data.money_format),
              linePriceConverted = Shopify.formatMoney(linePrice,app.data.money_format);                  
          
          

          var row = '<ul><li><div class="thumb"><a href="' + cart.items[i].url + 
              '"><img src="' + Shopify.addImageSize(cart.items[i].image,'small') + '" alt="' + cart.items[i].title + 
              '"></a></div></li><li><h5><a href="' + cart.items[i].url + 
              '" class="item-name">' + cart.items[i].product_title + 
                '</a></h5><p class="product-type">'+title+'</p><p>'+combined_value+'</p><a href="#" data-id="'+cart.items[i].id+'" class="remove_item_button">REMOVE</a></li>'+
              '<li><p class="mobile-label-price">Price</p><span class="money price">'+itemPriceConverted+'</span></li>'+
              '<li><p class="mobile-label-quantity">Quantity</p><a class="minus_btn"></a><input type="text" name="updates[]" class="txtbox" min="0" id="updates_'+cart.items[i].id+'" data-id="'+cart.items[i].id+'" value="'+cart.items[i].quantity+'" data-maxQtyVal="'+maxQtyVal+'" /><a class="plus_btn"></a>'+
              '<div class="ajaxcart__errors text-center ajaxcart__item__'+cart.items[i].id+'__errors">All available stock is in cart</div></li>'+    
              '<li><p class="mobile-label-total">Total</p><span class="money price">'+ linePriceConverted +'</span>'+
              '</li></ul>';
          toAppend.push(row);                       
           console.log(row); 
                }
        };

        // Execute the script after 1 second	
        setTimeout(function(){
        }, 1000);


        var checkoutRow = t.find('div.checkout_row'),
            subtotalRow = t.find('span.total-price'),
            subtotalRowCartPage = c.find("span.total-price");
        if(checkoutRow.length){ /* we have existing items in the quick cart */
          t.find('div.cart_row').html(toAppend.join(''));
          t.find('div.cart_row').prepend(tableHeader);
          c.find(".con_row").html(toAppend.join(''));
          subtotalRowCartPage.html(totalPriceConverted);
          subtotalRow.html(totalPriceConverted);
        }else{
          checkoutRow = '<div class="checkout_row clearfix"><button type="submit" name="checkout" value="Check Out" class="btn_c">Check Out</button> <a href="javascript:void(0)" class="info_btn"><span class="fa fa-chevron-left"></span>Continue Shopping</a></div>';
          subtotalRow = '<div class="total_row clearfix"><ul><li><span class="total_val">Subtotal:</span><span class="money total-price">'+totalPriceConverted+'</span></li></ul></div>';
          var addCheckOutBlock = '<div id="additional-checkout-block" class="text-right" ></div>';
          var form = jQ('<form />',{
            'action':'/cart',
            'method':'post',
            'novalidate':'novalidate'
          })
              
              if(true){
                var notesRow='<div class="clearfix order_notes">'+
                    '<label for="cartSpecialInstructions" class="sr-only">Your delivery instructions goes here. If you have a SECURITY CODE or call box number to access your building, please also mention it here.:</label>'+
                    '<textarea name="note" id="cartSpecialInstructionsFromPopup" class="note_text" placeholder="Your delivery instructions goes here. If you have a SECURITY CODE or call box number to access your building, please also mention it here.">'+ cartNote +'</textarea></div>';
              }
          else{
            var notesRow='';
          }
          form.append($("div.cart_row"));
          form.find("div.cart_row").html(toAppend.join(''));
          form.find('div.cart_row').prepend(tableHeader);
          form.append(subtotalRow);
          form.append(notesRow);
          
          form.append(checkoutRow);
          form.append(addCheckOutBlock);
          t.append(form);
   
        }
        
    

      }
      else{
        t.html('<div class="menu_title clearfix"><h4>Shopping Cart</h4> </div><div class="cart_row"><div class="empty-cart">Your cart is currently empty.</div><p><a href="javascript:void(0)" class="btn_c btn_close">Continue Shopping</a></p></div>'); 
        c.html('<div class="empty-cart-message"><p>Your cart is currently empty.</p><p><a href="/collections/all" class="btn_c">Continue Shopping</a></p></div');
       }  
      } 
        if(!$(selectors.CART_PAGE_MENU).length){
          setTimeout(function(){        
            Shopify.showModal($(selectors.QUICK_CART_MENU).wrap('<p>').parent().html());
          }, 500);
        }
        Shopify.onCartUpdate(cart);         
      
      };
      /**
 * This updates the N item/items left in your cart
 * 
 * It's setup to match the HTML used to display the Cart Count on Load. If you change that (in your theme.liquid) 
 * you will probably want to change the message html here. 
 * This will update the HTML in ANY element with the class defined in selectors.TOTAL_ITEMS
 *
 * @param object the cart object. 
 * @param HTMLElement form. If included, we know its an Update of the CART FORM, which will trigger additional behaviour. 
 */
      Shopify.onCartUpdate = function(cart, form) {

        // Total Items Update
        var message = cart.item_count;
        if(cart.item_count > 0){
          jQ(selectors.TOTAL_ITEMS).text(message).removeClass('hidden');
        }else{
          jQ(selectors.TOTAL_ITEMS).text('').addClass('hidden');
        }
      };

      Shopify.onError = function(XMLHttpRequest, textStatus) {
        var response = jQuery.parseJSON(XMLHttpRequest.responseText);
        var error = response.description;

        if(typeof $().magnificPopup !== 'function'){ 
          alert(error) ;
        }else{
          $.magnificPopup.open({
            items: {
              src: '<div class="mfp-with-anim modal-popup error"><h3>Error</h3>'+error+'</div>',
              type: 'inline'
            },
            mainClass: 'mfp-move-from-top',
            removalDelay: 1000
          });
        }
      };
      
      $(".cart_tbl").on("focusout","textarea", function(){
        var note = $(this).val(),
            textareas = jQ(selectors.QUICK_CART_MENU).find("textarea");

        Shopify.updateCartNote(note);
      });

      jQuery(".cart_tbl").on("click",".plus_btn", function () {
        var inputEl = jQuery(this).parent().find("input");
        var qty = inputEl.val();

        if (jQuery(this).hasClass("plus_btn"))
          qty++;
        else
          qty--;
        if (qty < 0)
          qty = 0;

        var quantity = qty,
            id = inputEl.data("id"),
            maxqtyval = inputEl.data("maxqtyval");

        if( (maxqtyval != 0) && (quantity > maxqtyval)){
            jQuery('.ajaxcart__item__' + id + '__errors').show().delay(3000).fadeOut();
        }
        else{
        
        Shopify.changeItem(id, quantity, function(cart){
          var updatedItem = cart.items.filter(function(item){ return item.variant_id == id });
          if(updatedItem.length && updatedItem[0].quantity == quantity){
            Shopify.updateQuickCart(cart);
            inputEl.val(quantity);
          }
          else{
            jQuery('.ajaxcart__item__' + id + '__errors').show().delay(3000).fadeOut();
          }
        });


        }


      })

      jQuery(".cart_tbl").on("click", ".minus_btn", function () {
        var inputEl = jQuery(this).parent().find("input");
        var qty = inputEl.val();
        if (jQuery(this).parent().hasClass("minus_btn"))
          qty++;
        else
          qty--;
        if (qty < 0)
          qty = 0;
        inputEl.val(qty);

        var quantity = qty,
            id = inputEl.data("id");
        if(quantity != 0){
          Shopify.changeItem(id, quantity, function(cart){
            Shopify.updateQuickCart(cart);
          });
        }
        else{
          Shopify.removeItem(id, function(cart){
            Shopify.updateQuickCart(cart);
          });
        }
      });

      $(".cart_tbl").on("click",".remove_item_button", function(e){
        e.preventDefault();

        var el = $(this),
            id = el.data('id') || null;

        Shopify.removeItem(id, function(cart){
          Shopify.updateQuickCart(cart);
        });
      });
      /// End  Changes for cart page  ///

      //End Wrapper    
    });
